export default "__VITE_ASSET__8fuLRcAg__"